import spacing from '@/constants/spacing';

export const SliderDefaults = {
  gap: spacing.xs * 1.5,
  padding: spacing.m,
  offset: spacing.l,
};
